import request from '@/utils/request';
import { setUrl } from '@/utils/schoolUrl';
/**
 * 获取校区列表
 */
export function fetchSchools(clientsId) {
  return request({
    url: `/api/packet/clients-list?clients_id=${clientsId}`,
    method: 'get',
  });
}
/**
 * 获取学科下的子分类
 * @Int clients_id 校区ID. 个人可不传或传0
 * @Int top_id 子分类id
 */
export function fetchCategoryChild(clientsId) {
  return request({
    url: '/api/courseware/category/tree',
    method: 'get',
    params: { clients_id: clientsId },
  });
}

/**
 * 获取学科下的课件
 * @Int clients_id 校区ID. 个人可不传或传0
 * @Int top_id 子分类id
 */
export function fetchCategoryCourse(params) {
  return request({
    url: '/api/packet/result-list',
    method: 'get',
    params: { 'equal[package_status]': 2, ...params },
  });
}
/**
 * 年级/学科类型
 */
export function fetchTag(type) {
  return request({
    url: '/api/tags',
    method: 'get',
    params: { 'order[order]': 'desc', 'equal[type]': type, per_page: 99 },
  });
}

/**
 * 课程列表
 * @Int clients_id 校区ID. 个人可不传或传0
 */
export function fetchPutOnList(params) {
  return request({
    url: '/api/packet/packet-list',
    method: 'get',
    params: { 'order[created_at]': 'desc', ...params },
  });
}

/**
 * 课程详情
 * @Int clients_id 校区ID. 个人可不传或传0
 */
export function fetchPacketDetail(id, clients_id) {
  return request({
    url: `/api/packet/packet-detail/${id}?clients_id=${clients_id}`,
    method: 'get',
  });
}
/**
 * 新增课程
 * @param {*} clients_id
 * @param {*} params
 * @returns
 */
export function createPacket(clients_id, data) {
  return request({
    url: `/api/packet/packet-add?clients_id=${clients_id}`,
    method: 'post',
    data,
  });
}
/**
 * 更新课程
 */

export function updatePacket(clients_id, data) {
  return request({
    url: `/api/packet/packet-update?clients_id=${clients_id}`,
    method: 'post',
    data,
  });
}
/**
 * 删除课程
 */

export function delPacket(clients_id, id) {
  return request({
    url: `/api/packet/packet-delete?clients_id=${clients_id}`,
    method: 'post',
    data: { id },
  });
}
/**
 * 课程上下架
 * @param {int} id 课程id
 * @param {int} sale_status 上下架状态
 * @returns
 */
export function updatePacketSale(clients_id, data) {
  return request({
    url: `/api/packet/packet-update-sale-status?clients_id=${clients_id}`,
    method: 'post',
    data,
  });
}
/**
 * 复制课程
 * @param {int} src_id 课程id
 * @returns
 */
export function copyPacket(clients_id, data) {
  return request({
    url: `/api/packet/packet-copy?clients_id=${clients_id}`,
    method: 'post',
    data,
  });
}

/**
 * 新增课时分类
 * @param {int} packet_id 课程id
 * @param {int} parent_id 父级课时分类Id
 * @param {string} name 课时分类名称
 * @returns
 */
export function createCategory(clients_id, params) {
  return request({
    url: `/api/packet/detail-category-add?clients_id=${clients_id}`,
    method: 'post',
    params,
  });
}
/**
 * 更新课时分类
 * @param {int} id 课时分类Id
 * @param {int} packet_id 课程id
 * @param {int} parent_id 父级课时分类Id
 * @param {string} name 课时分类名称
 * @returns
 */
export function updateCategory(clients_id, data) {
  return request({
    url: `/api/packet/detail-category-update?clients_id=${clients_id}`,
    method: 'post',
    data,
  });
}
/**
 * 删除课时分类
 * @param {int} id 课时分类Id
 * @param {int} packet_id 课程id
 * @returns
 */
export function delCategory(clients_id, data) {
  return request({
    url: `/api/packet/detail-category-delete?clients_id=${clients_id}`,
    method: 'post',
    data: { ...data },
  });
}
/**
 * 课时列表
 * @returns
 */
export function fetchPacketHours(id, clients_id) {
  return request({
    url: `/api/packet/detail-get-list?clients_id=${clients_id}`,
    method: 'get',
    params: {
      'equal[packet_id]': id,
      'order[sort]': 'asc',
      per_page: 9999,
    },
  });
}
/**
 * 提交课时编辑
 * @param {int} parent_id 父级课时分类Id
 * @param {array} result_list 课时列表
 */
export function updatePacketHours(clientsId, packetId, resultList) {
  return request({
    url: `/api/packet/detail-update-list?clients_id=${clientsId}`,
    method: 'post',
    data: { packet_id: packetId, result_list: resultList },
  });
}
/**
 * 课时移动
 * @param {int} packet_id 课程id
 * @param {int} detail_category_id 课时分类Id
 * @param {int} detail_list.detail_id 课时Id
 */
export function movePacketHours(clientsId, data) {
  return request({
    url: `/api/packet/batch-update-detail-category?clients_id=${clientsId}`,
    method: 'post',
    data: { ...data },
  });
}
/**
 * 批量授权-学校列表
 * @Int clients_id 校区ID. 个人可不传或传0
 */
export function fetchAuthSchool(clientsId, params) {
  return request({
    url: `api/packet/school-search-list?clients_id=${clientsId}`,
    method: 'get',
    params,
  });
}
/**
 * 批量授权-新增学校
 * @param {int} clients_code 校区编号
 */
export function createAuthSchool(clientsId, clients_code) {
  return request({
    url: `/api/packet/school-search-save?clients_id=${clientsId}`,
    method: 'post',
    data: { clients_code },
  });
}
/**
 * 批量授权-老师列表
 * @Int clients_id 校区ID. 个人可不传或传0
 */
export function fetchAuthTeacher(clientsId, params) {
  return request({
    url: `api/packet/school-staff-search-list?clients_id=${clientsId}`,
    method: 'get',
    params,
  });
}
/**
 * 批量授权-新增学校老师
 * @param {int} clients_code 校区编号
 */
export function createAuthTeacher(clientsId, data) {
  return request({
    url: `/api/packet/school-staff-search-save?clients_id=${clientsId}`,
    method: 'post',
    data: { ...data },
  });
}

/**
 * 批量授权课程
 * @param {int} clients_code 校区编号
 */
export function createAuthInfo(clientsId, data) {
  return request({
    url: `/api/packet/packet-auth-add?clients_id=${clientsId}`,
    method: 'post',
    data: { ...data },
  });
}
// 直播间扣费
// 一开始上课就间隔10秒轮询这个接口，服务端返回 200 状态就是收费计时正常进行着，
// 如果服务端连续3次不返回 200 状态，表示收费计时停止，这时提示停止上课。
export function setFee(schoolId, roomid) {
  return request({
    baseURL: setUrl(schoolId),
    url: `/api/liveroom/${roomid}/living`,
    method: 'patch',
  });
}



// WEBPACK FOOTER //
// ./src/api/courseOn.js